exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "  .modalPontoFisico .modal-content {\r\n    width: -webkit-max-content;\r\n    width: -moz-max-content;\r\n    width: max-content;\r\n  }\r\n\r\n  .cadastroPontoFisico:hover {\r\n    cursor: pointer;\r\n    color: red;\r\n  }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/setor/modal-setores-cliente/modal-setores-cliente.component.css
// module id = ../../../../../src/app/setor/modal-setores-cliente/modal-setores-cliente.component.css
// module chunks = main